import * as React from 'react';
export const AOSvg = React.forwardRef(function AOSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
        transform: 'translate(0 2)',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#333',
        d: 'M0 6v4.002C0 11.106.895 12 1.994 12h12.012A1.998 1.998 0 0 0 16 10.002V6H0Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#E25950',
        d: 'M1.994 0A1.998 1.998 0 0 0 0 1.998V6h16V1.998A1.997 1.997 0 0 0 14.006 0H1.994Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#F4B32E',
        d: 'M5.183 8.572a3.5 3.5 0 1 0 2.37-6.511 4 4 0 1 1-2.37 6.511Z',
      }),
      /*#__PURE__*/ React.createElement('circle', {
        cx: 7,
        cy: 4,
        r: 1,
        fill: '#F4B32E',
      }),
    ),
  );
});
AOSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
};
export var AO = {
  category: 'flag',
  colorable: false,
  name: 'AO',
  svg: AOSvg,
};
